import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { publicAPI } from '../../lib/api';
import { Loader2 } from 'lucide-react';

const PAGE_TITLES = {
  'kvkk': 'KVKK Aydinlatma Metni',
  'aydinlatma-metni': 'Aydinlatma Metni',
  'cerez-politikasi': 'Cerez Politikasi',
  'sorumluluk-metni': 'Sorumluluk Metni'
};

export default function LegalPage() {
  const location = useLocation();
  const page = location.pathname.replace('/', '');
  const title = PAGE_TITLES[page];
  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    publicAPI.getContent('legal').then(r => {
      const html = r.data[page] || '';
      setContent(html);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [page]);

  if (!title) return <div className="min-h-screen flex items-center justify-center"><h1 className="text-2xl">Sayfa bulunamadi</h1></div>;

  return (
    <>
      <Helmet>
        <title>{title || 'Yasal'}</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <section className="py-12">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          {loading ? (
            <div className="flex items-center justify-center py-12"><Loader2 className="h-6 w-6 animate-spin" /></div>
          ) : content ? (
            <div className="prose prose-slate max-w-none" dangerouslySetInnerHTML={{ __html: content }} data-testid="legal-content" />
          ) : (
            <div className="text-center py-12 text-muted-foreground">
              <p>Bu sayfanin icerigi henuz eklenmemis.</p>
              <p className="text-sm mt-2">Admin Panel > Icerik (CMS) > "legal" bolumunden duzenleyebilirsiniz.</p>
            </div>
          )}
        </div>
      </section>
    </>
  );
}
